import React, { useEffect } from 'react';
import { signinRedirectCallback, loadAndGetUserProfile } from 'shared/services/userService';
import { useNavigate } from 'react-router-dom';
import { Spinner } from '../components/ui/Spinner';

const SigninOidc = () => {
    const navigate = useNavigate();

    useEffect(() => {
        async function signinAsync() {
            console.log('SigninOidc');
            await signinRedirectCallback();

            // Load the user's profile and wait for it to be available
            const userProfile = await loadAndGetUserProfile();

            // Set the rulebookMode based on the user's cbtcTrained status
            if (userProfile?.cbtcTrained) {
                localStorage.setItem('rulebookMode', 'cbtc');
                console.log("User is CBTC trained")
            } else {
                localStorage.setItem('rulebookMode', 'traditional');
                console.log("User is Traditional")
            }

            const locationPath = sessionStorage.getItem("pre-login-route");
            const redirectPath = (typeof locationPath === 'string' && locationPath) ? locationPath : '/';
            
            sessionStorage.removeItem("pre-login-route");
            navigate(redirectPath);
        };

        signinAsync();
    }, [navigate]);

    return (
        <div className="login-status">
            Signing in
            <Spinner />
        </div>
    );
}

export default SigninOidc